"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteActivity = exports.updateActivities = exports.insertActivity = exports.getActivities = exports.ActivitySlice = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var ReduxStoreHelper_1 = require("../../youwell-common/ReduxStoreHelper");
var arrayUtils_1 = require("../../youwell-common/arrayUtils");
var initialState = {
    activities: null,
    activitiesLoadedFrom: null,
};
exports.ActivitySlice = (0, toolkit_1.createSlice)({
    name: 'ActivitySlice',
    initialState: initialState,
    reducers: {
        getActivities: function (state, action) {
            var _a, _b, _c;
            state.activities = (0, arrayUtils_1.distinct)(__spreadArray(__spreadArray([], state.activities || [], true), action.payload.response || [], true));
            state.activitiesLoadedFrom = ((_a = action.payload.requestQuery) === null || _a === void 0 ? void 0 : _a.start) || ((_c = (_b = action.payload.response) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.date) || null;
        },
        insertActivity: function (state, action) {
            if (action.payload.response) {
                state.activities = state.activities ? (0, arrayUtils_1.sortByDateAscending)(__spreadArray(__spreadArray([], state.activities, true), [action.payload.response], false), 'date') : null;
            }
        },
        updateActivities: function (state, action) {
            state.activities = state.activities ? state.activities.map(function (a) { return (action.payload.response && a.id === action.payload.response.id ? action.payload.response : a); }) : null;
        },
        deleteActivity: function (state, action) {
            state.activities = state.activities ? state.activities.filter(function (a) { var _a; return a.id !== ((_a = action.payload.requestBody) === null || _a === void 0 ? void 0 : _a.id); }) : null;
        },
    },
    extraReducers: (_a = {},
        _a[ReduxStoreHelper_1.LOGOUT] = function () { return initialState; },
        _a),
});
exports.getActivities = (_b = exports.ActivitySlice.actions, _b.getActivities), exports.insertActivity = _b.insertActivity, exports.updateActivities = _b.updateActivities, exports.deleteActivity = _b.deleteActivity;
exports.default = exports.ActivitySlice.reducer;
